var ct_admin = 'CT Admin';
var coo_admin = 'COO Admin';
var tc = 'TC';
var gp = 'GP';
var doctor = 'Doctor';
var front_office = 'Front Office';
var location_manager = 'Location Manager';
var lite = 'LITE';
var pro = 'PRO';
var enterprise = 'ENTERPRISE';

if (process.env.ENV === 'production') {
    var baseUrl = 'https://ortho.practicecatapult.com/backend/';
    var StripeKey = 'pk_live_054mDdGEPN4T55i22kQZjf0a';
    var stripe_client_id = 'ca_BjsbgLD3DdvOEnzpXKcSgjuRlxKSzCDB';
}else if (process.env.ENV === 'uat'){
    var baseUrl = 'https://uat.practicecatapult.com/backend/';
    var StripeKey = 'pk_test_xv7cmsol9WxtyW24qiOuA65A';
    var stripe_client_id = 'ca_BHWi0KNtn0HB5NJiU7LeJV37dvsgpQpW';
}else if (process.env.ENV === 'qa'){
    var baseUrl = 'https://qa.practicecatapult.com/backend/';
    var StripeKey = 'pk_test_xv7cmsol9WxtyW24qiOuA65A';
    var stripe_client_id = 'ca_BHWi0KNtn0HB5NJiU7LeJV37dvsgpQpW';
}else {
    var baseUrl = 'https://qa.practicecatapult.com/backend/';
    var StripeKey = 'pk_test_xv7cmsol9WxtyW24qiOuA65A';
    var stripe_client_id = 'ca_BHWi0KNtn0HB5NJiU7LeJV37dvsgpQpW';
}

export const config = {
    baseStyle: {},
    baseUrl: baseUrl,
    photoUrl: '',
    package: 'package',
    storage_key: 'ct_access',
    role: 'ct_role',
    stripe_client_id : stripe_client_id,
    menu_list: 'menu_list',
    dentist: 'Dentist',
    patient: 'Patient',
    coo_admin: 'COO Admin',
    StripeKey: StripeKey,
    gp: 'GP',
    tc: 'TC',
    doctor: 'Doctor',
    location_manager: 'Location Manager',
    ct_admin: 'CT Admin',
    front_office: 'Front Office',
    language: 'language',
    country: 'country',
    languages: [{ id: 'en', title: 'English' }],
    page_auth: {
        'subscription': { roles: [coo_admin] },
        'case-study-list': { roles: [coo_admin, ct_admin, location_manager] },
        'doctor-referral-list': { roles: [coo_admin, tc, location_manager], subscription: [pro, enterprise] },
        'patient-referral-list': { roles: [coo_admin, location_manager, tc], subscription: [pro, enterprise] },
        'reports': { roles: [coo_admin, location_manager, tc, ct_admin, doctor] },
        'change-password': { roles: [coo_admin, location_manager, tc, ct_admin, doctor, front_office] },
        'pricing': { roles: [coo_admin, location_manager] },
        'set-goals': { roles: [coo_admin, location_manager] },
        'geography-settings': { roles: [coo_admin] },
        'demographic-settings': { roles: [coo_admin, location_manager] },
        'practice-profile': { roles: [coo_admin] },
        'insurance-plan': { roles: [coo_admin] },
        'follow-up-communication': { roles: [coo_admin, tc, location_manager] },
        'profile': { roles: [coo_admin, tc, doctor, location_manager, ct_admin, front_office] },
        'patient-file-list': { roles: [tc, doctor, location_manager, coo_admin, front_office] },
        'ct-category': { roles: [ct_admin] },
        'ct-promocode': { roles: [ct_admin] },
        'insurance-plan-management': { roles: [ct_admin] },
        'subscription-pricing': { roles: [ct_admin] },
        'add-case-study': { roles: [ct_admin, coo_admin, location_manager], subscription: [pro, enterprise] },
        'view-case-study': { roles: [ct_admin, coo_admin, location_manager] },
        'allocate-case-study': { roles: [ct_admin] },
        'language-settings': { roles: [coo_admin, location_manager] },
        'ortho-calculator': { roles: [tc] },
        'patient-presenter': { roles: [tc] },
        'gp-gallery': { roles: [gp] },
        'patient-file-add': { roles: [tc, front_office] },
        'patient-file-view': { roles: [tc, doctor, front_office, coo_admin, location_manager] },
        'practice-list': { roles: [ct_admin] },
        'practice-add': { roles: [ct_admin] },
        'practice-view': { roles: [ct_admin] },
        'practice-delete': { roles: [ct_admin] },
        'enterprise-list': { roles: [ct_admin] },
        'enterprise-add': { roles: [ct_admin] },
        'enterprise-delete': { roles: [ct_admin] },
        'create-referral': { roles: [coo_admin, tc, location_manager] },
        'treatment-plan': { roles: [tc, doctor, coo_admin, location_manager] },
        'user-list': { roles: [coo_admin, location_manager] },
        'user-add': { roles: [coo_admin, location_manager] },
        'user-view': { roles: [coo_admin, location_manager] },
        'email-template' : { roles: [coo_admin, tc, location_manager]}
    },
    currency: {
        'USD' : '$',
        'EUR' : '€',
        'INR' : '₹'
    },
    dateFormat: {
        'US' : 'MM/DD',
        'IE' : 'DD/MM',
        'EN' : 'DD/MM',
        'AU' : 'MM/DD'
    },
    emailRegex: /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])+\.[a-zA-Z0-9-]{2,}?(?:\.[a-zA-Z](?:[a-zA-Z]{0,61}[a-zA-Z])?)*$/,
    emailRegexPattern: "^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])+\.[a-zA-Z0-9-]{2,}?(?:\.[a-zA-Z](?:[a-zA-Z]{0,61}[a-zA-Z])?)*$",
    termsOfUseUrl: 'https://practicecatapult.com/termsofuse/',
    privacyPolicyUrl: 'https://practicecatapult.com/privacy-policy/',
    orthoCatapultUrl: 'https://orthocatapult.com/'
};